// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pli-charge {
  padding: 20px 0;
  border-bottom: 1px solid var(--border-soft);
}
.pli-charge__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.pli-charge__head .plp-detail__h {
  margin: 0;
}
.pli-charge__offers {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.pli-charge__offer {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 8px 12px;
  border: 1px solid var(--border-soft);
  border-radius: 6px;
  cursor: pointer;
  font-size: var(--fs-ui);
  color: var(--text);
}
.pli-charge__offer:has(input:checked) {
  border-color: var(--accent);
}
.pli-charge__offer-main {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}
.pli-charge__price {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
}
.pli-charge__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.pli-charge__link {
  display: block;
  margin-top: 8px;
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text);
  overflow-wrap: anywhere;
}
.pli-charge__actions .plp-rowbtn,
.pli-charge__head .plp-morebtn,
.pli-charge__actions .plp-morebtn {
  min-height: 44px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/plataforma/whatsapp/ChannelPayinPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;;;EAGE,gBAAgB;AAClB","sourcesContent":[".pli-charge {\n  padding: 20px 0;\n  border-bottom: 1px solid var(--border-soft);\n}\n.pli-charge__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.pli-charge__head .plp-detail__h {\n  margin: 0;\n}\n.pli-charge__offers {\n  list-style: none;\n  margin: 12px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.pli-charge__offer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 44px;\n  padding: 8px 12px;\n  border: 1px solid var(--border-soft);\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: var(--fs-ui);\n  color: var(--text);\n}\n.pli-charge__offer:has(input:checked) {\n  border-color: var(--accent);\n}\n.pli-charge__offer-main {\n  flex: 1;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.pli-charge__price {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n}\n.pli-charge__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 12px;\n}\n.pli-charge__link {\n  display: block;\n  margin-top: 8px;\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text);\n  overflow-wrap: anywhere;\n}\n.pli-charge__actions .plp-rowbtn,\n.pli-charge__head .plp-morebtn,\n.pli-charge__actions .plp-morebtn {\n  min-height: 44px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
